import { Plan } from '@modules/super-admin/company/domain';
import { CacheableState } from '@utils/cacheable-state';

export interface MembershipState {
  allPlans: CacheableState<Array<Plan>>;
  allCards: CacheableState<Array<any>>;
  deleteCard: CacheableState<Array<any>>;
  payMembership: CacheableState<Array<any>>;
  addCard: CacheableState<Array<any>>;
  updateMembership: CacheableState<Array<any>>;
  cancelMembership: CacheableState<Array<any>>;
}

export function membershipInitialState(): MembershipState {
  return {
    allPlans: initialDataSubState().allPlans,
    allCards: initialDataSubState().allCards,
    deleteCard: initialDataSubState().deleteCard,
    payMembership: initialDataSubState().payMembership,
    addCard: initialDataSubState().addCard,
    updateMembership: initialDataSubState().updateMembership,
    cancelMembership: initialDataSubState().cancelMembership,
  };
}
export function initialDataSubState(): MembershipState {
  return {
    allPlans: new CacheableState(),
    allCards: new CacheableState(),
    deleteCard: new CacheableState(),
    payMembership: new CacheableState(),
    addCard: new CacheableState(),
    updateMembership: new CacheableState(),
    cancelMembership: new CacheableState(),
  };
}
